<div class="" *ngIf="message">
    <div class="p-grid">
        <div class="p-col-4 p-lg-2 p-md-2 p-sm-2">
            <button pButton type="submit" class="fullwidthbtn" label="Submit" (click)="submiteMessage()"></button>
        </div>
        <div class="p-col-4 p-lg-2 p-md-2 p-sm-2">
            <button pButton type="button" class="fullwidthbtn" label="Edit" (click)="backToMessageAdd()"></button>
        </div>
        <div class="p-col-4 p-lg-2 p-md-2 p-sm-2">
            <button pButton type="button" class="fullwidthbtn" label="Cancel" (click)="cancelReview()"></button>
        </div>
    </div>
    
    <div class="card">
        <div class="message-header">{{message.HeadLine}}</div>        
        <p-divider></p-divider>
        <div class="p-grid">
            <div class="p-col-12 p-lg-5 p-md-5">
                <strong>Presented By:</strong>
                <p-button label=" {{message.ContactName}}" styleClass="p-button-link"></p-button>
            </div>
            <div class="p-col-12 p-lg-7 p-md-7"><strong>Deal Type:</strong>{{message.DealTypeName}}</div>
            <div class="p-col-12 p-lg-5 p-md-5"><strong>Phone Number: {{formatPhoneNumber(message.ContactPhone)}}</strong></div>
            <div class="p-col-12 p-lg-7 p-md-7"><strong>Property:</strong>{{message.PropertyTypeName}}</div>
            <div class="p-col-12 p-lg-5 p-md-5">
                <strong>Email: </strong><p-button label="{{message.ContactEmail}}" styleClass="p-button-link" (click)="NavMailto()"></p-button>
            </div>
            <div class="p-col-12 p-lg-7 p-md-7"><strong>Location:</strong>{{getLocation()}}</div>
            <div class="p-col-12 p-lg-9 p-md-9"><strong>Admin Email:</strong>{{message.AdminEmail}}</div>
            <div class="p-col-12 p-lg-12 p-md-12" innerHTML="{{message.BroadcastBody}}"></div>
            <div class="p-col-12 p-lg-12 p-md-12">
                <strong>Attachments:</strong>
                <ul>
                    <li *ngFor="let doc of message.Attachments">
                        <a class="hyperLink">{{doc.name}}</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>
<p-confirmDialog header="Confirmation" key="reviewMessageConfirmDialog" icon="pi pi-exclamation-triangle"></p-confirmDialog>
    
